import { Component, Suspense, lazy, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { voiceStatus } from '../lib/voice';
import { RobotFace } from './RobotFace';
import { useMode } from '../lib/profiles';
import { usePolicy } from '../lib/policy';
import { TEAM, agentForMode } from '../lib/agentTeam';

const AgentChat = lazy(() => import('./AgentChat'));

// a crash inside the voice chat must never take down the app
class Guard extends Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) { toast.error(`${this.props.name}: ${err?.message || err}`, { duration: 10000 }); this.props.onClose(); }
  render() { return this.state.err ? null : this.props.children; }
}

// top-bar robot button: talk to the ElevenLabs agent (e.g. "Leakbuster")
export default function AgentButton({ t, lang, project }) {
  const [base, setCfg] = useState(null);
  const mode = useMode(), { kritis } = usePolicy();
  // every branch has its own agent (lib/agentTeam); Leakbuster for detection and the full view
  const ak = agentForMode(mode.startsWith('detect') ? 'detect' : mode);
  const cfg = base && (ak !== 'lb' && base.dripx ? { id: null, key: ak, name: TEAM[ak].name, lbName: base.name } : base);
  const [open, setOpen] = useState(false);
  useEffect(() => { voiceStatus().then((s) => s.agent_id && setCfg({ id: s.agent_id, name: s.agent_name || 'Agent', dripx: s.dripx })); }, []);
  useEffect(() => { const on = () => setOpen(true); window.addEventListener('giss-agent-open', on); return () => window.removeEventListener('giss-agent-open', on); }, []);
  if (!cfg || kritis) return null;
  const close = () => setOpen(false);
  return (
    <>
      <button className="chip agent-chip" data-testid="leakbuster-btn" onClick={() => setOpen(true)} title={`${cfg.name} – ${t.lbTip}`} aria-label={cfg.name}><RobotFace size={20} /> <span>{cfg.name}</span></button>
      {open && createPortal(
        <Guard name={cfg.name} onClose={close}>
          <Suspense fallback={<div className="lb-panel" data-testid="leakbuster-panel"><p className="lb-hint">{t.lbConnecting}</p></div>}>
            <AgentChat key={cfg.key || cfg.name} t={t} lang={lang} cfg={cfg} project={project} onClose={close} />
          </Suspense>
        </Guard>,
        document.body,
      )}
    </>
  );
}
